import React from 'react';

import { Checkbox, FormControlLabel } from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import RadioButtonCheckedRoundedIcon from '@material-ui/icons/RadioButtonCheckedRounded';
import RadioButtonUncheckedRoundedIcon from '@material-ui/icons/RadioButtonUncheckedRounded';

import { IMetaFormat } from '../../../../../store/admin/roundFormats/store';

interface IProps {
  metaFormatToUpdate: IMetaFormat;
  onSaveMetaFormat: (format: IMetaFormat) => void;
}

export const HowTeamsScore = (props: IProps) => {
  const { metaFormatToUpdate, onSaveMetaFormat } = props;

  const {
    format: { id: formatId },
    aggregations
  } = metaFormatToUpdate;

  const onScoreAggregationChange = ({ target: { value } }: any) => {
    const newAggregations = aggregations.includes(Number(value))
      ? aggregations.filter(prevAggregation => prevAggregation !== Number(value))
      : [...aggregations, Number(value)];

    onSaveMetaFormat({ ...metaFormatToUpdate, aggregations: newAggregations });
  };

  const onScoresCountChange = ({ target: { value } }: any) => {
    onSaveMetaFormat({ ...metaFormatToUpdate, relevantScores: Number(value) });
  };

  return (
    <>
      <p className="format-label">HOW WILL TEAMS BE SCORED?</p>

      <FormControlLabel
        className="round-subformat-checkbox override"
        classes={{ label: 'label' }}
        control={
          <Checkbox
            className="check-gross-score"
            id={`check-${formatId}-gross-score`}
            checked={aggregations.includes(1)}
            onChange={onScoreAggregationChange}
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={<CheckBoxIcon fontSize="large" />}
            value="1"
            color="primary"
          />
        }
        label="Total Score"
      />

      <FormControlLabel
        className="round-subformat-checkbox override"
        classes={{ label: 'label' }}
        control={
          <Checkbox
            className="check-gross-score"
            id={`check-${formatId}-net-score`}
            checked={aggregations.includes(2)}
            onChange={onScoreAggregationChange}
            icon={<CheckBoxOutlineBlankIcon fontSize="large" />}
            checkedIcon={<CheckBoxIcon fontSize="large" />}
            value="2"
            color="primary"
          />
        }
        label="Better Ball"
      />

      {aggregations.includes(2) && (
        <div className="how-teams-score">
          <span className="format-label players-per-team">HOW MANY SCORES COUNT?</span>

          {[1, 2, 3].map((index: number) => (
            <FormControlLabel
              key={`round-subformat-checkbox-${index}`}
              className="round-subformat-checkbox override"
              classes={{ label: 'label' }}
              control={
                <Checkbox
                  className="check-considered-flight"
                  id={`check-considered-flight-${formatId}`}
                  checked={metaFormatToUpdate.relevantScores === index}
                  onChange={onScoresCountChange}
                  icon={<RadioButtonUncheckedRoundedIcon fontSize="large" />}
                  checkedIcon={<RadioButtonCheckedRoundedIcon fontSize="large" />}
                  value={String(index)}
                  color="primary"
                />
              }
              label={index}
            />
          ))}
        </div>
      )}
    </>
  );
};
